<section class="opening-requirements-btn" (click)="closeRequirements=!closeRequirements">
	<i class="fa fa-2x fas fa-bars"></i>
</section>
<aside class="password-requirements" id="passwordRequirements"
	   [ngClass]="closeRequirements ? 'closed-requirement' : ''">
	<div class="closing-requirements-btn" (click)="closeRequirements=!closeRequirements">
		<img src="../../../assets/img/{{themeService.theme}}/close-btn1.svg" alt="">
	</div>
	<div class="expanations-container">
		<div class="title">Password Requirements</div>
		<div class="subtitle">Your password must contain at least:</div>
		<div class="expanations-list">
			<label class="check-label">
				10 Characters
				<input type="checkbox" checked="checked" class="form-check-input">
				<span class="checkmark"
					  [ngClass]="singUpForm.controls['password'].hasError('required') || singUpForm.controls['password'].hasError('minlength')  ? 'background-danger' : 'background-success'"></span>
			</label>
			<label class="check-label">
				1 Upper Case Character
				<input type="checkbox" checked="checked" class="form-check-input">
				<span class="checkmark"
					  [ngClass]="singUpForm.controls['password'].hasError('required') || singUpForm.controls['password'].hasError('hasCapitalCase')  ? 'background-danger' : 'background-success'"></span>
			</label>
			<label class="check-label">
				1 Lower Case Character
				<input type="checkbox" checked="checked" class="form-check-input">
				<span class="checkmark"
					  [ngClass]="singUpForm.controls['password'].hasError('required') || singUpForm.controls['password'].hasError('hasSmallCase')  ? 'background-danger' : 'background-success'"></span>
			</label>
			<label class="check-label">
				1 Number
				<input type="checkbox" checked="checked" class="form-check-input">
				<span class="checkmark"
					  [ngClass]="singUpForm.controls['password'].hasError('required') || singUpForm.controls['password'].hasError('hasNumber')  ? 'background-danger' : 'background-success'"></span>
			</label>
			<label class="check-label">
				1 Special Character
				<input type="checkbox" checked="checked" class="form-check-input">
				<span class="checkmark"
					  [ngClass]="singUpForm.controls['password'].hasError('required') || singUpForm.controls['password'].hasError('hasSpecialSymbol')  ? 'background-danger' : 'background-success'"></span>
			</label>
		</div>
	</div>
</aside>
<section class="sign-container sign-up-password-container">
	<img class="sign-in-background" src="../../../assets/img/{{themeService.theme}}/zp-lg-background.png" alt="">
	<section class="navbar-brand">
		<img src="../../assets/img/{{themeService.theme}}/{{themeService.theme == 'bluecoat' ? 'main-logo' : 'scd-logo'}}.png" alt="Company Logo" width="125px" [ngClass]="{'img-theme-nav-bar': themeService.theme == 'life-file'}">
	</section>
	<!-- <div class="sign-account" [routerLink]="['/sign-in']">Already have an account? Sign In</div> -->
	<section class="container" [ngClass]="{'bluecoat-login-card': themeService.theme == 'bluecoat'}">
		<form [formGroup]="singUpForm" (ngSubmit)="onSubmit()">
			<h1 class="serif-title" [ngClass]="{'nwr-color-title': themeService && themeService.theme == 'NWRTheme'}">Sign Up</h1>
      <div class="notification-bubble-container">
        <app-notification-bubble timeout="{{null}}"></app-notification-bubble>
      </div>
			<section class="sign-get-info">
				<section class="form-group">
					<input type="email" class="form-control" placeholder="Email Address" formControlName="email"
						   [ngClass]="{ 'is-invalid': submitted && f.email.errors }"/>
					<div *ngIf="submitted && f.email.errors" class="invalid-feedback">
						<div *ngIf="f.email.errors.required">Email is required</div>
						<div *ngIf="f.email.errors.email">Email must be a valid email address</div>
					</div>
				</section>
				<section class="form-group caps-lock-section">
					<input [type]="statusPassword ? 'text' : 'password'" class="form-control" placeholder="Password"
						   formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
						   (capsLock)="capsOn=$event"/>
					<i class="caps-lock-icon fa fas fa-eye" (click)="statusPassword = !statusPassword"></i>
					<i class="caps-lock-icon fa fas fa-eye-slash" (click)="statusPassword = !statusPassword"
					   [ngClass]="!statusPassword ? 'eye-slash' : '' "></i>
					<div *ngIf="capsOn" class="warning-caps-locked">Caps Locked</div>
					<div *ngIf="submitted && f.password.errors" class="invalid-feedback">
						<div *ngIf="f.password.errors.required">Password is required</div>
						<div *ngIf="f.password.errors.minlength">Must be at least 10 characters</div>
						<div *ngIf="f.password.errors.hasCapitalCase">Must contain at least 1 in Capital Case</div>
						<div *ngIf="f.password.errors.hasSmallCase">Must contain at least 1 in Small Case</div>
						<div *ngIf="f.password.errors.hasNumber">Must contain at least 1 number</div>
						<div *ngIf="f.password.errors.hasSpecialSymbol">Must contain at least 1 special character</div>
					</div>
				</section>
				<section class="form-group form-check">
					<div class="terms-of-use" >
						<label class="check-label">
							<span class="agreement">
								I agree to the
								<ng-container *ngIf="showTermsOfService">
									<a href="https://zenplans.com/wp-content/uploads/2023/02/Zenplans-Sponsor-Terms-Conditions-2.1.pdf" target="_blank" class="terms-of-use-link" [ngClass]="{'nwr-color-title': themeService && themeService.theme == 'NWRTheme'}">terms of use.</a>
								</ng-container>
								<ng-container *ngIf="!showTermsOfService">
									<a href="https://zenplans.com/wp-content/uploads/2023/02/Zenplans-End-User-Terms-Conditions-2.1.pdf" target="_blank" class="terms-of-use-link" [ngClass]="{'nwr-color-title': themeService && themeService.theme == 'NWRTheme'}">terms of use.</a>
								</ng-container>
							</span>

							<input type="checkbox" checked="checked" class="form-check-input"
								   formControlName="acceptTerms"
								   [ngClass]="{ 'is-invalid': submitted && f.acceptTerms.errors }">
							<span class="checkmark"></span>
							<div *ngIf="submitted && f.acceptTerms.errors"
								 class="invalid-feedback invalid-feedback-terms-policy">Accept Terms of Use is required
							</div>
						</label>
					</div>

					
					<div class="privacy-policy">
						<label class="check-label">
							<span class="agreement">I agree to the <a class="privacy-link" href="https://zenplans.com/wp-content/uploads/2023/08/Zenplans-Privacy-Cookies-Policy-2.1.pdf" target="_blank"> privacy policy.</a></span>
							<input type="checkbox" checked="checked" class="form-check-input"
								   formControlName="acceptPolicy"
								   [ngClass]="{ 'is-invalid': submitted && f.acceptPolicy.errors }"/>
							<span class="checkmark"></span>
							<div *ngIf="submitted && f.acceptPolicy.errors"
								 class="invalid-feedback invalid-feedback-terms-policy">Accept Privacy Policy is
								required
							</div>
						</label>
					</div>
				</section>
				<input type="submit" class="form-control btn btn-primary primary-default-btn" value="Sign Up" [ngClass]="{'nwr-theme-input': themeService.theme == 'NWRTheme'}">
				<div class="sign-account sign-account-mobile" [routerLink]="['/sign-in']">Already have an account? Sign
					In
				</div>
			</section>
		</form>

  </section>
</section>
<app-footer></app-footer>
